import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import styles from './Location.module.css';

const Location = () => {
  const [ref, inView] = useInView({ 
    triggerOnce: true, 
    threshold: 0.15 
  });

  return (
    <section className={styles.section} id="location" data-section="location" ref={ref}>
      <div className={styles.gridBackground}></div>

      <div className={styles.container}>
        
        <motion.div 
          className={styles.contentWrapper}
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6 }}
        >
          
          {/* Left Content */}
          <div className={styles.leftPanel}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              <div className={styles.sectionLabel}>Location</div>
              <h2 className={styles.title}>Visit Our Office</h2>
            </motion.div>

            <motion.div 
              className={styles.addressBlock}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <div className={styles.infoGroup}>
                <div className={styles.label}>Address</div>
                <div className={styles.value}>
                  Stellato Mall, 3rd Floor<br />
                  Ngong Road<br />
                  Nairobi, Kenya
                </div>
              </div>

              <div className={styles.infoRow}>
                <div className={styles.infoGroup}>
                  <div className={styles.label}>Phone</div>
                  <div className={styles.value}>
                    +254 708 277 8484<br />
                    +254 700 000 000
                  </div>
                </div>

                <div className={styles.infoGroup}>
                  <div className={styles.label}>Email</div>
                  <div className={styles.value}>
                    hello@scorex.io<br />
                    sales@scorex.io
                  </div>
                </div>
              </div>

              <div className={styles.infoGroup}>
                <div className={styles.label}>Hours</div>
                <div className={styles.value}>
                  Monday - Friday: 8:00 AM - 6:00 PM<br />
                  Saturday: 9:00 AM - 2:00 PM<br />
                  Sunday: Closed
                </div>
              </div>
            </motion.div>

            <motion.div 
              className={styles.actionButtons}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <button className={styles.primaryBtn}>
                Get Directions
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <button className={styles.secondaryBtn}>
                Schedule Visit
              </button>
            </motion.div>
          </div>

          {/* Right Map */}
          <motion.div 
            className={styles.mapPanel}
            initial={{ opacity: 0, x: 20 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            <div className={styles.mapContainer}>
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8419910230054!2d36.805649573727386!3d-1.2675587356033409!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f177eeede9d77%3A0x9aca12aebaf58602!2sStellato%20Mall!5e0!3m2!1sen!2ske!4v1762701733958!5m2!1sen!2ske" 
                width="100%" 
                height="100%" 
                style={{ border: 0 }} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Scorex Location"
              ></iframe>
            </div>
          </motion.div>

        </motion.div>

      </div>
    </section>
  );
};

export default Location;